module.exports = __webpack_public_path__ + "3b5b7ea71dd29a048fc71989d5975139.png";